import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addTaxRuleAPI, provisionalPayslipAPI, taxRuleListAPI, updateTaxRuleAPI,
    newPayslipAPI, payslipListAPI, payslipDetailAPI, updatePayslipPaymentStatusAPI
} from '../api-requests/payroll';
import {
    newTaxRuleRequestError, newTaxRuleRequestSuccess, provisionalPayslipRequestError,
    provisionalPayslipRequestSuccess, taxRuleListRequestError, taxRuleListRequestSuccess,
    updateTaxRuleRequestError, updateTaxRuleRequestSuccess, newPayslipRequestError,
    newPayslipRequestSuccess, payslipListRequestError, payslipListRequestSuccess,
    payslipDetailRequestError, payslipDetailRequestSuccess, updatePayslipPaymentRequestError,
    updatePayslipPaymentRequestSuccess
} from './payroll.action';
import { PayrollActionTypes } from './payroll.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handleUpdatePayslipPaymentRequest({ payload }) {
    try {
        const response = yield call(updatePayslipPaymentStatusAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updatePayslipPaymentRequestSuccess(decryptedData))
            } else {
                yield put(updatePayslipPaymentRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updatePayslipPaymentRequestError(error.response.data))
        }
    }
}

export function* updatePayslipPaymentReq() {
    yield takeLatest(PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST, handleUpdatePayslipPaymentRequest)
}

function* handlePayslipDetailRequest({ payload }) {
    try {
        const response = yield call(payslipDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(payslipDetailRequestSuccess(decryptedData))
            } else {
                yield put(payslipDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(payslipDetailRequestError(error.response.data))
        }
    }
}

export function* payslipDetailReq() {
    yield takeLatest(PayrollActionTypes.PAYSLIP_DETAIL_REQUEST, handlePayslipDetailRequest)
}

function* handlePayslipRequest({ payload }) {
    try {
        const response = yield call(payslipListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(payslipListRequestSuccess(decryptedData))
            } else {
                yield put(payslipListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(payslipListRequestError(error.response.data))
        }
    }
}

export function* payslipReq() {
    yield takeLatest(PayrollActionTypes.PAYSLIP_LIST_REQUEST, handlePayslipRequest)
}

function* handleNewPayslipRequest({ payload }) {
    try {
        const response = yield call(newPayslipAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(newPayslipRequestSuccess(decryptedData))
            } else {
                yield put(newPayslipRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(newPayslipRequestError(error.response.data))
        }
    }
}

export function* newPayslipReq() {
    yield takeLatest(PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST, handleNewPayslipRequest)
}

function* handleUpdateTaxRuleRequest({ payload }) {
    try {
        const response = yield call(updateTaxRuleAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateTaxRuleRequestSuccess(decryptedData))
            } else {
                yield put(updateTaxRuleRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateTaxRuleRequestError(error.response.data))
        }
    }
}

export function* updateTaxRuleReq() {
    yield takeLatest(PayrollActionTypes.UPDATE_TAX_RULE_REQUEST, handleUpdateTaxRuleRequest)
}

function* handleTaxRuleListRequest({ payload }) {
    try {
        const response = yield call(taxRuleListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(taxRuleListRequestSuccess(decryptedData))
            } else {
                yield put(taxRuleListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(taxRuleListRequestError(error.response.data))
        }
    }
}

export function* taxRuleListReq() {
    yield takeLatest(PayrollActionTypes.TAX_RULE_LIST_REQUEST, handleTaxRuleListRequest)
}

function* handleProvisionalPayslipRequest({ payload }) {
    try {
        const response = yield call(provisionalPayslipAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(provisionalPayslipRequestSuccess(decryptedData))
            } else {
                yield put(provisionalPayslipRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(provisionalPayslipRequestError(error.response.data))
        }
    }
}

export function* provisionalPayslipReq() {
    yield takeLatest(PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST, handleProvisionalPayslipRequest)
}

function* handleAddTaxRuleRequest({ payload }) {
    try {
        const response = yield call(addTaxRuleAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(newTaxRuleRequestSuccess(decryptedData))
            } else {
                yield put(newTaxRuleRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: PayrollActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(newTaxRuleRequestError(error.response.data))
        }
    }
}

export function* newTaxRuleReq() {
    yield takeLatest(PayrollActionTypes.NEW_TAX_RULE_REQUEST, handleAddTaxRuleRequest)
}